import { useMutation } from 'react-query';
import {
  patchActionAwaitClientDecision,
  patchActionContinueWithOffer,
  patchActionRejectOffer,
} from './index';

export const useMutationContinueWithOffer = () =>
  useMutation(async (offerId) => {
    await patchActionContinueWithOffer(offerId);
    return;
  });

export const useMutationAwaitClientDecision = () =>
  useMutation(async (offerId) => {
    await patchActionAwaitClientDecision(offerId);
    return;
  });

export const useMutationRejectOffer = () =>
  useMutation(async (offerId) => {
    await patchActionRejectOffer(offerId);
    return;
  });
